import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            partners: [],
            activeTab: 'active'
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        }
    },
    mutations: {
        setPartners(state, value) {
            state.partners = value;
        },
        addPartner(state, value) {
            state.partners.data.unshift(value);
        },
        removePartner(state, item) {
            for (let i = 0; i < state.partners.data.length; i++) {
                if (state.partners.data[i].id === item.id) {
                    window.Vue.delete(state.partners.data, i, item);
                }
            }
        },
        updatePartnerState(state, item) {
            for (let i = 0; i < state.partners.data.length; i++) {
                if (state.partners.data[i].id === item.id) {
                    window.Vue.set(state.partners.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/partner', payload)
                    .then((response) => {
                        commit('setPartners', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allPartners({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/partner/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getPartner({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/partner/'+ id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deleteItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/partner/'+ id)
                    .then((response) => {
                        commit('removePartner',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        restoreItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/partner/'+ id + '/restore')
                    .then((response) => {
                        commit('removePartner',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getReferralPayments({state, commit, getters}, {id, page}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/partner/'+ id + '/referral-payments', { page: page })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getReferralActions({state, commit, getters}, {id, start, end}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/partner/'+ id + '/referral-actions', { start: start, end: end })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    }
};


